module.exports = __webpack_public_path__ + "static/media/imgSelfProductionBenefits.8575595a.png";